import { Routes } from '@angular/router';
import { authRoutes } from './features/auth/auth.routes';
import { legalRoutes } from './features/legal/legal.routes';
import { personsRoutes } from './features/persons/persons.routes';
import { scoreboardRoutes } from './features/scoreboard/scoreboard.routes';
import { settingsRoutes } from './features/settings/settings.routes';
import { sponsorsRoutes } from './features/sponsors/sponsors.routes';
import { sportScoreboardPresetsRoutes } from './features/sport-scoreboard-presets/sport-scoreboard-presets.routes';
import { exerciseTemplatesRoutes } from './features/exercise-templates/exercise-templates.routes';
import { exerciseMatchesRoutes } from './features/exercise-matches/exercise-matches.routes';
import { playbookRoutes } from './features/playbook/playbook.routes';
import { myTeamRoutes } from './features/my-team/my-team.routes';
import { sportsRoutes } from './features/sports/sports.routes';
import { stadiumsRoutes } from './features/stadiums/stadiums.routes';
import { statkeeperCliRoutes } from './features/statkeeper-cli/statkeeper-cli.routes';
import { statkeeperRoutes } from './features/statkeeper/statkeeper.routes';
import { usersRoutes } from './features/users/users.routes';
import { weaponsRoutes } from './features/weapons/weapons.routes';
import { scopesRoutes } from './features/scopes/scopes.routes';
import { bulletsRoutes } from './features/bullets/bullets.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/home/components/home.component').then((m) => m.HomeComponent),
  },
  ...authRoutes,
  ...sportScoreboardPresetsRoutes,
  ...exerciseTemplatesRoutes,
  ...sportsRoutes,
  ...personsRoutes,
  ...stadiumsRoutes,
  ...sponsorsRoutes,
  ...weaponsRoutes,
  ...scopesRoutes,
  ...bulletsRoutes,
  ...usersRoutes,
  ...settingsRoutes,
  ...scoreboardRoutes,
  ...exerciseMatchesRoutes,
  ...statkeeperRoutes,
  ...statkeeperCliRoutes,
  ...playbookRoutes,
  ...myTeamRoutes,
  ...legalRoutes,
  {
    path: 'error404',
    loadComponent: () =>
      import('./shared/components/error404/error404.component').then((m) => m.Error404Component),
  },
  {
    path: '**',
    redirectTo: '/error404',
  },
];
